import { defineMessages } from '@/shared/i18n/define';

/** Textos propios de los avisos globales. */
export const feedbackMsgs = defineMessages(
  'feedback',
  {
    modal: {
      error: 'Algo salió mal',
      warning: 'Atención',
      success: 'Listo',
      info: 'Aviso',
      code: 'Código {code}',
    },
    conflict: {
      title: 'Tus ajustes cambiaron en otro dispositivo',
      body: 'La cuenta tiene una versión más nueva de tus preferencias. Elige con cuál quedarte; no se pierde nada hasta que decidas.',
      server: 'Usar la de la cuenta',
      serverHelp: 'Guardada el {date}, con {count} favoritos.',
      local: 'Usar este dispositivo',
      localHelp: 'Tiene {count} favoritos y sustituirá a la de la cuenta.',
      merge: 'Mezclar favoritos',
      mergeHelp: 'Mantiene los ajustes de este dispositivo y suma los favoritos de ambos lados.',
    },
    offline: {
      withDate: 'Sin conexión · datos del {date}',
      noDate: 'Sin conexión · mostrando lo último guardado',
      apiDownWithDate: 'Sin respuesta del servidor · datos del {date}',
      apiDown: 'Sin respuesta del servidor · mostrando lo último guardado',
      refresh: 'Reintentar',
    },
  },
  {
    modal: {
      error: 'Something went wrong',
      warning: 'Heads up',
      success: 'Done',
      info: 'Notice',
      code: 'Code {code}',
    },
    conflict: {
      title: 'Your settings changed on another device',
      body: 'Your account has a newer version of your preferences. Choose which one to keep; nothing is lost until you decide.',
      server: 'Use the account version',
      serverHelp: 'Saved on {date}, with {count} favorites.',
      local: 'Use this device',
      localHelp: 'It has {count} favorites and will replace the account version.',
      merge: 'Merge favorites',
      mergeHelp: 'Keeps this device settings and adds the favorites from both sides.',
    },
    offline: {
      withDate: 'Offline · data from {date}',
      noDate: 'Offline · showing the last saved data',
      apiDownWithDate: 'No answer from the server · data from {date}',
      apiDown: 'No answer from the server · showing the last saved data',
      refresh: 'Retry',
    },
  },
);
